import createPaginatedListReducerWithNamedType from 'store/hoReducers/paginatedList/reducer';
import { PURGE_ACTIONS } from 'store/services/project/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

const reducerHandlers = (state = initialState, action = {}) => ({
  [PURGE_ACTIONS]: () => ({
    ...state,
    list: {
      ...state.list,
      data: {
        ...state.list.data,
        items: state.list.data.items.filter(
          o => !action.payload.data.rule_groups.includes(o.id),
        ),
      },
    },
    show: {
      ...state.show,
      data: {},
    },
  }),
  [types.GET_RULE_GROUPS_ALL_SUCCESS]: () => ({
    ...state,
    all: {
      ...state.all,
      isLoading: false,
      data: action.payload.items,
      count: action.payload.count,
    },
  }),
  [types.GET_RULE_GROUPS_FULL_LIST]: () => ({
    ...state,
    full: {
      ...state.full,
      isLoading: false,
      data: action.payload.items,
    },
  }),
  [types.PARTIAL_UPDATE_RULE_GROUPS_REQUEST]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: true,
    },
  }),
  [types.PARTIAL_UPDATE_RULE_GROUPS_SUCCESS]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
    },
  }),
  [types.PARTIAL_UPDATE_RULE_GROUPS_ERROR]: () => ({
    ...state,
    partialUpdate: {
      ...state.partialUpdate,
      isLoading: false,
      error: action.payload.error,
    },
  }),
  [types.SET_EMPTY_RULE_GROUPS]: () => ({
    ...state,
    list: {
      ...state.list,
      isLoading: false,
      data: {
        ...state.list.data,
        items: [],
      },
      filterOptions: action.payload.filterOptions,
      filterParams: action.payload.filterParams,
      paginationOptions: action.payload.paginationOptions,
    },
  }),
  [types.MOVE_RULE_TO_GROUP]: () => ({
    ...state,
    list: {
      ...state.list,
      data: {
        ...state.list.data,
        items: action.payload.items,
      },
    },
  }),
  [types.GET_RULE_GROUPS_LIST_TOTAL_COUNT]: () => ({
    ...state,
    list: {
      ...state.list,
      totalCount: action.payload.totalCount,
    },
  }),
  [types.DESELECT_RULE_MATCHED_FILTER_PARAMS]: () => ({
    ...state,
    list: {
      ...state.list,
      filterParams: {},
    },
  }),
});

export default createPaginatedListReducerWithNamedType(
  'RULE_GROUPS',
  initialState,
  reducerHandlers,
);
